import React from 'react'
import './Landing.css'
import NavBarSignupButton from '../../components/Buttons/NavBarSignupButton/NavBarSignupButton'
import NavBar from '../../components/NavBar/NavBar'
import Hero from '../../components/Hero/Hero'
import Feature from '../../components/Feature/Feature'
import Business from '../../components/Business/Business'
import Footer from '../../components/Footer/Footer'
import Community from '../../components/Community/Community'
import AffiliationCard from '../../components/AffiliationCard/AffiliationCard'
import Categories from '../../components/Categories/Categories'
import Ads from '../../components/Ads/Ads'
import DownloadButtons from '../../components/DownloadButtons/DownloadButtons'
const Landing = () => {
  return (
    <>
    <NavBar/>
    <Hero/>
    <DownloadButtons/>
    <Feature/>
    <Business/>
    <Community/>
    <AffiliationCard/>
    <Categories/>
    <Ads/>
    <Footer/>
    </>
  )
}

export default Landing